const MODULE = 'COLLAPSABLES'
export const TOGGLE_ITEM_COLLAPSE = `${MODULE}/TOGGLE_ITEM_COLLAPSE`
